module.exports = __webpack_public_path__ + "img/PAMMAccountLogo5.4f8dd132.svg";